module.exports = __webpack_public_path__ + "assets/img/button-Fachwerktag.b5ee3144.svg";